<template>
  <div class="wrap">

    <form v-on:submit.prevent="sendMessage" v-show="!emailSubmited" method="post">
      <div class="form-group">
        <label class="sr-only" for="userName" v-html="c('nameLabel')"></label>
        <input type="text" id="userName" v-model="userData.name" placeholder="{{ c('nameLabel') }}">
      </div>
      <div class="form-group">
        <label class="sr-only" for="userEmail" v-html="c('emailLabel')"></label>
        <input type="email" id="userEmail" v-model="userData.email" placeholder="{{ c('emailLabel') }}">
      </div>
      <div class="form-group">
        <label class="sr-only" for="userCompany" v-html="c('companyLabel')"></label>
        <input type="text" id="userCompany" v-model="userData.company" placeholder="{{ c('companyLabel') }}">
      </div>
      <div class="form-group">
        <label class="sr-only" for="userMessage" v-html="c('messageLabel')"></label>
        <textarea id="userMessage" v-model="userData.message" placeholder="{{ c('messageLabel') }}"></textarea>
      </div>
      <ul>
        <li><button type="reset" v-on:click="cancelMessage" v-html="c('cancelLabel')"></button></li>
        <li><button type="submit" v-html="c('submitLabel')"></button></li>
      </ul>
    </form>

    <div v-show="emailSubmited">
      <h2 v-html="c('emailSent')" v-show="emailSuccess"></h2>

      <h2 v-html="c('emailNotSentTitle')" v-show="!emailSuccess"></h2>
      <p v-html="c('emailNotSentDescription')" v-show="!emailSuccess"></p>

      <button v-on:click="goBack" v-html="c('emailBackButton')"></button>
    </div>

  </div>
</template>

<script>
var content = require('../assets/content.json')

export default {
  data () {
    return {
      content: content,
      userData: {
        name: '',
        email: '',
        company: '',
        message: ''
      },
      emailSubmited: false,
      emailSuccess: false
    }
  },
  methods: {
    sendMessage: function () {
      // sends email

      this.$http.post('api/sendmail', this.userData).success(function (response) {
        console.log('message submitted')
        this.emailSuccess = true
      }).error(function (error) {
        console.log(error)
      })

      this.emailSubmited = true
    },

    cancelMessage: function () {
      this.$route.router.go({ name: 'hello' })
    },

    goBack: function () {
      this.emailSubmited = false
      this.$route.router.go({ name: 'hello' })
    }

  }
}
</script>



// WEBPACK FOOTER //
// Contact.vue?67972d70